import React from 'react';
import './CarrierSection.css';

const CarrierSection: React.FC = () => {
  return (
    <section id="carrier" className="carrier-section">
      <div className="carrier-container">
        <div className="carrier-header">
          <div className="section-label">Carriers</div>
          <h2 className="carrier-title">Bring your own carrier.</h2>
          <p className="carrier-description">
            Cut through the clutter of rigid telecom contracts. With Taar.AI, you can partner directly with
            Airtel, Jio, or Tata to secure low-cost, fully compliant SIP lines tailored to your scale — from
            30 channels to 5000+. Choose your number series (+91 92xxx, +91 80, +91 79, and more)
            without the baggage of physical offices or last-mile headaches. We terminate your SIP lines
            straight into our data centers, eliminating local infra dependencies and shielding you from
            disruptions like roadworks. You stay lean, resilient, and in complete control.
          </p>
        </div>

        <div className="carrier-highlights">
          <div className="carrier-partnerships">
            <h3 className="partnership-title">Bring Your Own Carrier</h3>
            <p className="partnership-subtitle">Partner directly with Airtel, Jio, or Tata</p>
            <div className="carrier-logos">
              <div className="carrier-logo">
                <span className="logo-text">Airtel</span>
              </div>
              <div className="carrier-logo">
                <span className="logo-text">Jio</span>
              </div>
              <div className="carrier-logo">
                <span className="logo-text">Tata</span>
              </div>
            </div>
          </div>
          
          <div className="carrier-benefits">
            <h3 className="benefit-title">No Local Office Required</h3>
            <p className="benefit-description">
              Deploy anywhere in India — no physical offices, no infrastructure setup, no local dependencies. 
              Our platform handles all compliance and carrier relationships while you focus on your business.
            </p>
          </div>
        </div>

        <div className="carrier-content">
          <table className="simple-table">
            <thead>
              <tr>
                <th>Feature Description</th>
                <th><img src="https://assets.taar.ai/logo.png" alt="Taar.AI" className="table-logo" /></th>
                <th>Aggregators</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Partner directly with Airtel/Jio/Tata trunks</td>
                <td>✓</td>
                <td>✗</td>
              </tr>
              <tr>
                <td>Scale 30-5000 channels with flat infra costs</td>
                <td>✓</td>
                <td>✗</td>
              </tr>
              <tr>
                <td>Pick your own number series (+91 92xxx, 80, 169...)</td>
                <td>✓</td>
                <td>✗</td>
              </tr>
              <tr>
                <td>Terminate SIP in Tier-3 data centers, no local infra</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td>Full observability: MoS, jitter, SIP tracing</td>
                <td>✓</td>
                <td>✗</td>
              </tr>
              <tr>
                <td>Kubernetes-native deploys + self-PBX</td>
                <td>✓</td>
                <td>✗</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default CarrierSection;
